export enum DiscountScope {
  ONLY_LATEST = "ONLY_LATEST",
  CURRENT_CART = "CURRENT_CART",
  FULL_RECEIPT = "FULL_RECEIPT",
}
